// adminSections.ts
export interface AdminSection {
    label: string;
    route?: string;
    id?: string;
    children?: AdminSection[];
  }
  
export const adminSections = [
  { label: 'Data center', route: '/kontrol/admin-center/data-center' },
  { label: 'Third party Ports', route: '/kontrol/admin-center/third-party' },
  { label: 'Hardware', route: '/kontrol/admin-center/hardware' },
  { label: 'Port', route: '/kontrol/admin-center/port' },
  { label: 'Fiber coverage', route: '/kontrol/admin-center/lastMile' },
  { label: 'Data center connections', route: '/kontrol/admin-center/dc-connections' },
  { label: 'Tenants', 
    id: 'tenants',
    children: [
      {
        label: "Partners",
        route:"/kontrol/admin-center/partners"
      },
      {
        label: "Customers",
        route:"/kontrol/admin-center/customers"
      }
    ]
  },
  { label: 'IP block', route: '/kontrol/admin-center/ip-block' },
  { label: 'Public subnet stock', route: '/kontrol/admin-center/public-subnet' },
];
  